/**
 * ChannelDetailWrapper
 *
 * Wrapper de detail view com breadcrumb "← Canais > [Canal]".
 * Delega para o plugin renderizar o conteúdo do detail (ou connect flow).
 */

import React from 'react';
import { IconArrowLeft } from '@tabler/icons-react';

const ChannelDetailWrapper = ({
  agentId,
  channel,
  navigation,
  mode = 'detail', // 'detail' | 'connect'
  onAlertCTA,
  onConnected,
}) => {
  const Icon = channel.icon;

  const renderContent = () => {
    if (mode === 'connect' && typeof channel.renderConnectFlow === 'function') {
      return channel.renderConnectFlow(agentId, onConnected, navigation.goBackToGrid);
    }
    if (typeof channel.renderDetail === 'function') {
      return channel.renderDetail(agentId, navigation, onAlertCTA);
    }
    return (
      <div style={{ padding: 24, textAlign: 'center', color: '#6b7280' }}>
        Detalhes do canal "{channel.name}" não implementados.
      </div>
    );
  };

  return (
    <div className="channel-detail-wrapper">
      <div className="channel-detail-wrapper__header">
        <button
          type="button"
          className="channel-detail-wrapper__back-btn"
          onClick={navigation.goBackToGrid}
        >
          <IconArrowLeft size={16} />
          Canais
        </button>
        <span className="channel-detail-wrapper__divider">›</span>
        <div className="channel-detail-wrapper__title">
          <span
            className="channel-detail-wrapper__icon"
            style={{ background: '#1877f2', color: "#fff" }}
          >
            <Icon size={16} />
          </span>
          <span>{channel.name}</span>
          {mode === 'connect' && (
            <span className="channel-detail-wrapper__mode-badge">Conexão</span>
          )}
        </div>
      </div>

      <div className="channel-detail-wrapper__content">{renderContent()}</div>
    </div>
  );
};

export default ChannelDetailWrapper;
